// MEDVOL: M10-11303 changes ========================================
import { Button } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { useState } from "react";
import { escalatedCompany } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
// import { useEventStatus } from "src/hooks/useEventStatus";
// import { useSelector } from "react-redux";
// import { RootState } from "src/context/store";

const EscalatedToCompany = ({
    onCloseModal,
    invoiceData,
    tab,
}: {
    onCloseModal: () => void;
    invoiceData: any;
    company_code?: any[];
    division_code?: any[];
    startDate?: Date | string;
    endDate?: Date | string;
    assignee_id?: any[];
    city?: any[];
    district?: any[];
    state?: any[];
    ordering?: any[];
    status?: any[];
    tab?: string;
    fuidStatusId?: number
}) => {
    const [remarks, setRemarks] = useState<string>("");
    //   const [rejectionCategory, setRejectionCategory] = useState<any>([]);
    //   const [rejectionCategoryId, setRejectionCategoryId] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    //   const { withEventCheck } = useEventStatus();

    const { toast } = useToast();

    //   const fetchRejectionCategory = async () => {
    //     const res = await getRejectionCategory(company_code);
    //     setRejectionCategory(res?.data?.data);
    //   };

    //   useEffect(() => {
    //     fetchRejectionCategory();
    //   }, []);

    const handleInvoiceReject = async () => {
        setIsLoading(true);
        const payload = {
            data: {
                escalated_action: "pending",
                stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
                company_code: invoiceData?.company_code,
                state_code: invoiceData?.orderCodes?.[0]?.reference_order?.novu_metadata?.state_code,
                division_code: invoiceData?.orderCodes?.[0]?.reference_order?.novu_metadata?.DivisionDetails?.company_divisioncode,
                escalated_from: tab,
                escalated_remarks: remarks
            },
            primary_key: invoiceData?.stockist_invoice_attachment_id,
            event_type: "INVOICE_COMPANY_ESCALATION_ADD",
        };
        try {
            //   if (!rejectionCategoryId) {
            //     toast({ description: "Please select a category of rejection", variant: "destructive" });
            //     return;
            //   }
            const res = await escalatedCompany(payload, invoiceData?.company_code);
            console.log(res)
            toast({ description: "Escalated To Company successfully", variant: "default" });
            onCloseModal();
        } catch (error: any) {
            console.log(error);
        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    return (
        <div className="flex flex-col gap-y-2 w-[500px] h-[400px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Escalated To Company</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            {/* <p className="text-sm mb-2 font-normal text-[#666666]">Select a category of Escalate</p>
      <Autocomplete
        inputClassName="w-full"
        placeholder="E-Invoice is mandatory"
        suggestionList={rejectionCategory}
        displayKey="rejection_inv_category_desc"
        uniqueKey="rejection_inv_category_id"
        onSelectionChange={(e: any) => setRejectionCategoryId(e?.rejection_inv_category_id)}
      /> */}
            <p className="pt-2">Remarks</p>
            <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Write your remarks here"
                className="p-2 mb-2 resize-none border bg-[#f7f7f7] max-h-[120px] h-[120px] border-gray-300 rounded-md"
            />
            <Button disabled={isLoading} isLoading={isLoading} loaderSize="small" className="text-white bg-[#8051FF]" onClick={handleInvoiceReject}>
                Proceed
            </Button>
        </div>
    );
};

export default EscalatedToCompany;
// MEDVOL: M10-11303 changes ========================================
